import IconButton from "components/IconButton";
import { navWidth } from "components/LeftMenu/LeftMenu.styles";
import { fadeIn } from "react-animations";
import styled, { DefaultTheme, keyframes } from "styled-components";
import { pageTitle } from "styles/typography";

const rangeHeightParams = (theme: DefaultTheme): [string, string, string, string] => [
  "70px",
  "90px",
  `${theme.breakpoints.sm}px`,
  `${theme.breakpoints.xl}px`,
];

export const HeaderWrapper = styled.header`
  ${({ theme }) => theme.range("height", ...rangeHeightParams(theme))}
  ${({ theme }) => theme.range("min-height", ...rangeHeightParams(theme))}
    
    ${(props) => props.theme.sm`
      min-height: 60px;
      height: 60px;
    `}
`;

interface HeaderProps {
  $withMenu?: boolean;
}

// Fixed, so its width is viewport-relative: subtract the left menu only when
// one is rendered (/shipping has none).
export const Header = styled.div<HeaderProps>`
  position: fixed;
  width: ${({ $withMenu }) => ($withMenu ? `calc(100% - ${navWidth})` : "100%")};
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${({ theme }) => theme.range("padding", "15px", "30px")};
  height: inherit;
  max-height: inherit;
  transition: height 0.2s ease-out;
  z-index: 1;
  background-color: ${({ theme }) => theme.surface};
  border-bottom: ${({ theme }) => theme.headerBorder};

  &::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 100%;
    height: 20px;
    background: linear-gradient(
      to bottom,
      ${({ theme }) => theme.surface},
      transparent
    );
    pointer-events: none;
  }

  ${(props) => props.theme.sm`
    width: 100%;
  `}
`;

export const BasicHeaderWrapper = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  animation: 0.8s ${keyframes`${fadeIn}`};

  ${({ theme, hidden }) =>
    hidden &&
    theme.sm`
        display: none;
    `}
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  margin-left: 12px;
`;

export const HeaderTitle = styled.span`
  flex: 1;
  margin: 0;
  padding: 0;
  font-size: 26px;
  ${pageTitle}
  white-space: nowrap;

  ${(props) => props.theme.sm`
      width: 100%;
      text-align: center;
    `}
`;

export const MobileMenuButton = styled(IconButton)`
  animation: 0.8s ${keyframes`${fadeIn}`};
`;
